import React from "react";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import ProductsTab from "@insightfulscience/atomic-react/ProductsTab";
import { Col, Container, Row } from "@insightfulscience/atomic-react/Grid";
import Section from "@insightfulscience/atomic-react/Section";
import Panel from "@insightfulscience/atomic-react/Panel";
import Heading from "@insightfulscience/atomic-react/Heading";
import ContentContainer from "@insightfulscience/atomic-react/r1/atoms/ContentContainer";
import NextLink from "@insightfulscience/smart-react/NextLink";
import routes from "../../routes";
import FreeTrialForm from "../../FreeTrialForm";
import WithServices from "../../services";
import withErrorHandling from "../../AppError/withErrorHandling";
import SiteLayout from "../../SiteLayout";
import WithMaintenance from "../../Maintenance/WithMaintenance";
import { usePreventBFCache } from "../../nav-utils";

const iconPrime = "/images/geneious/logo/icon-prime.svg";
const iconBiologics = "/images/geneious/logo/icon-biologics.svg";

const FreeTrialPage = () => {
	const [t] = useLocale("free-trial");

	usePreventBFCache();

	return (
		<SiteLayout isWrapper={false}>
			<PageMeta title={t("META.TITLE")} description={t("META.DESCRIPTION")}>
				<PageMeta.OGP
					locale={t("META.LOCALE")}
					type={t("META.TYPE")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					url={t("META.URL")}
					siteName={t("META.SITE_NAME")}
					articlePublisher={t("META.ARTICLE_PUBLISHER")}
				/>
				<PageMeta.Canonical href={t("META.CANONICAL")} />
				<PageMeta.Twitter
					card={t("META.TWITTER_CARD")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					site={t("META.TWITTER_SITE")}
					creator={t("META.TWITTER_CREATOR")}
				/>
			</PageMeta>
			<Section utility={{ bgColor: "dotmatics-4" }}>
				<Row utility={{ bgColor: "white" }} spacing={{ pt: 9 }}>
					<Col>
						<Container>
							<Row>
								<Col md="auto">
									<ProductsTab
										logoIcon={iconPrime}
										borderColor="3"
										title={t("TAB1.TITLE")}
										description={t("TAB1.DESCRIPTION")}
										active
										data-qa-selector="geneious-prime-tab"
									/>
								</Col>
								<Col md="auto">
									<NextLink
										href={routes.external.externalGetStartedBiologics}
										logoIcon={iconBiologics}
										borderColor="dotmatics-7"
										title={t("TAB2.TITLE")}
										description={t("TAB2.DESCRIPTION")}
										data-qa-selector="geneious-biologics-tab"
										Component={ProductsTab}
									/>
								</Col>
							</Row>
						</Container>
					</Col>
				</Row>
			</Section>
			<Section utility={{ bgColor: "dotmatics-4" }} spacing={{ py: 20 }}>
				<ContentContainer md={6} center>
					<Panel spacing={{ py: 12, px: 12 }} sx={{ textAlign: "center" }}>
						<div>
							<Heading Tag="h2" size="l" data-qa-selector="free-trial-main-heading">
								{t("TITLE_FIRST_LINE")} <br /> {t("TITLE_SECOND_LINE")}
							</Heading>
							<Paragraph
								sx={{ fontColor: "black--custom-1", fontSize: "l" }}
								data-qa-selector="free-trial-description-paragraph"
							>
								{t("SUB_TITLE")}
							</Paragraph>
							<FreeTrialForm />
						</div>
					</Panel>
				</ContentContainer>
			</Section>
		</SiteLayout>
	);
};

export default pipe(
	FreeTrialPage,
	withErrorHandling,
	WithServices,
	WithMaintenance({ level: "NEW_ECOMM_AND_SIGNUPS" }),
);
